import VanillaTilt from 'vanilla-tilt';

VanillaTilt.init(document.querySelectorAll(".tilt"), {
    max: 10,
    glare: false,
    speed: 400,
});
